import { supabase } from "@/integrations/supabase/client";

/**
 * Logs an SMS opt-in event to the sms_consent_log table for Twilio A2P 10DLC compliance.
 * Captures the exact consent text shown, timestamp, IP (best-effort), and user agent.
 */
export async function logSmsConsent(params: {
  userId: string | null;
  phone: string;
  source: "signup_alerts" | "signup_marketing" | "booking_acknowledgment" | string;
  consentText: string;
}) {
  try {
    let ip: string | null = null;
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      if (res.ok) {
        const json = await res.json();
        ip = json?.ip ?? null;
      }
    } catch {
      // IP lookup is best-effort; ignore failures
    }

    await supabase.from("sms_consent_log").insert({
      user_id: params.userId,
      phone: params.phone,
      consent_source: params.source,
      consent_text: params.consentText,
      ip_address: ip,
      user_agent: typeof navigator !== "undefined" ? navigator.userAgent : null,
    });
  } catch (err) {
    console.error("Failed to log SMS consent:", err);
  }
}

export const SMS_CONSENT_TEXT = {
  alerts:
    "By checking this box, you agree to receive recurring SMS appointment confirmations, reminders, receipts, and review requests from In Paradise Beauty at the phone number provided (up to ~5 messages per appointment). Msg & data rates may apply. Reply STOP to opt out, HELP for help. See SMS terms at /sms-consent and Privacy Policy at /privacy-policy.",
  marketing:
    "By checking this box, you agree to receive recurring marketing and promotional SMS messages from In Paradise Beauty at the phone number provided (up to ~4 messages per month). Msg & data rates may apply. Consent is not a condition of purchase. Reply STOP to opt out, HELP for help. See SMS terms at /sms-consent.",
  bookingAcknowledgment:
    "I confirm my booking and consent to receive recurring SMS & email notifications from In Paradise Beauty about this appointment (up to ~5 messages per appointment). Msg & data rates may apply. Reply STOP to opt out, HELP for help. See SMS terms at /sms-consent.",
};
